// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const DashboardsList    = lazy(() => import('../../views/dashboardscoc/list'))

const DashboardsCOC = [
  {
    path: 'dashboardscoc/list',
    element: <DashboardsList />
  }
]

export default DashboardsCOC
